import SavingsCuts from '@/components/savings_cuts/SavingsCuts'
import SavingsCutCreate from '@/components/savings_cuts/SavingsCutCreate'
import SavingsCutUpdate from '@/components/savings_cuts/SavingsCutUpdate'
import SavingsCutDetail from '@/components/savings_cuts/SavingsCutDetail'

const savingsCutsRoutes = [
  { path: '/savings_cuts', name: 'savings_cuts', component: SavingsCuts },
  { path: '/savings_cut/create', name: 'savings_cut_create', component: SavingsCutCreate },
  { path: '/savings_cut/:id/update', name: 'savings_cut_update', component: SavingsCutUpdate },
  { path: '/savings_cut/:id', name: 'savings_cut', component: SavingsCutDetail }
]

export default savingsCutsRoutes



// WEBPACK FOOTER //
// ./src/router/savings_cuts_routes.js